<i18n>
{
	"en": {
		"title" : "Confirm deletion of EDIPART by pressing OK",
		"edipartHeader" : "EDI-parts",
		"edipartNameDisplay" : "Edipart navn",
		"newEdipart" : "New edipart",
		"delete" : "Delete edipart",
		"notifyEdipartDeleted": "EDI part deleted"
	},

	"no": {
		"title" : "For å bekrefte sletting av EDIPART - Trykk OK",
		"edipartHeader" : "EDI-parter",
		"edipartNameDisplay" : "Edipart navn",
		"newEdipart" : "Ny edipart",
		"delete" : "Slett edipart",
		"notifyEdipartDeleted": "EDI part slettet"
	}
}
</i18n>

<template>
	<t-vertical-panel class="edipart-list">
		<div slot="header" class="edipart-list-header">
			<t-panel-header size="md" type="bp" icon="settings">
				{{$t('edipartHeader')}}
			</t-panel-header>
			<t-button
				:value="$t('newEdipart')"
				appearance="minimal"
				type="bp"
				iconBefore="plus"
				@click="newEdipart"
			/>
		</div>
		<NewEdipart
			:showNewEdipartDialog="show"
			@close="show = false"
			@cancel="show = false"
		/>
		<t-grid
			ref="grid"
			:key="'edipartOverview'"
			style="width:100%"
			:columnDefinitions="columnDefinitions"
			:defaultColumnDefinition="defaultColumnDefinition"
			:rowHeight="50"
			:items="ediparts"
			@rowDoubleClick="showEdipartSettings"
		>

			<template v-slot:name="{ displayValue }">
				<div v-if="displayValue" class="edipart-center-text">{{ displayValue}}</div>
			</template>
			<template v-slot:button="{ item }">
				<t-button
					style="padding-left:1em;"
					:value="$t('delete')"
					disabled
					appearance="minimal"
					type="bp"
					iconBefore="minus"
					@click="deleteEdipart(item)"
				/>
			</template>
		</t-grid>


		<t-dialog
			:title="$t('title')"
			:icon="'minus'"
			:isShown="isDeleteEdipartDialogShown"
			iconType="bp"
			@close="isDeleteEdipartDialogShown = false"
			@ok="executeDelete"
			@cancel="isDeleteEdipartDialogShown = false"
		/>
	</t-vertical-panel>
</template>

<script>

import Grid from '@/components/evergreen/timpex/grid/TGrid';
import { mapActions, mapGetters } from './store/edipart.store';
import { mapActions as mapDetailsAction } from './store/details/ediSetupDetails.store';
import NewEdipart from './newEdipart/NewEdipart.vue';
import deepCopy from 'deepcopy';
export default {
	components: { TGrid: Grid, NewEdipart },
	data: () => ({
		defaultColumnDefinition: { resizable: true },
		show: false,
		isDeleteEdipartDialogShown: false,
		selectedEdipart: undefined,
	}),
	computed: {
		...mapGetters(['ediparts']),

		columnDefinitions() {
			return [
				{
					field: 'name',
					displayName: this.$t('edipartNameDisplay'),
					resizable: true,
				},
				{
					field: 'button',
					displayName: this.$t('delete'),
					resizable: true,
				}
			];
		},

	},

	async created() {
		await this.executeGetEdiparts();
	},
	methods: {
		...mapActions([ 'executeGetEdiparts', 'executeDeleteEdipart' ]),
		...mapDetailsAction(['executeSetEdipart']),

		newEdipart() {
			if (this.show)
				this.show = false;
			else
				this.show = true;
		},
		executeDelete() {
			this.executeDeleteEdipart(this.selectedEdipart);
			this.$notify({
				type:'success',
				title: this.$t('notifyEdipartDeleted')
			});
		},
		showEdipartSettings(value) {
			let selectedEdipartCopy = deepCopy(this.ediparts.find(x => x.id === value));
			this.executeSetEdipart(selectedEdipartCopy);
			this.$emit('showDetails');
		},
		deleteEdipart(item) {
			this.selectedEdipart = item;
			this.isDeleteEdipartDialogShown = true;
		},
	},

};
</script>

<style lang="scss" scoped>
.edipart-list{
	.edipart-list-header{
		display:flex;
		align-items: center;
		height: 100%;
		padding: 0 2em 1em 2em;
	}
}

.edipart-center-text{
	display:flex;
	justify-content: center;
}
</style>